import { useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { scrollToTop } from "../../utils/Helper";

const LegalPage = ({ title, children }) => {
  useEffect(() => {
    const previousTitle = document.title;
    scrollToTop();
    document.title = `${title} | Happy Ending`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <div className="wrapper legal-page">
      <Header isBackEnable={true} />
      <main className="legal-main">
        <section className="legal-hero">
          <div className="container">
            {/* <p className="legal-eyebrow">Happy Ending</p> */}
            <h1>{title}</h1>
          </div>
        </section>
        <section className="legal-content-section">
          <div className="container">
            <article className="legal-content">{children}</article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
